import { jsx } from 'react/jsx-runtime';
import { createRoot } from 'react-dom/client';
import { Prompt } from './Prompt.js';

const targetId = "samdesk-prompt-element";
let target = document.getElementById(targetId);
if (!target) {
    target = document.createElement("div");
    target.id = targetId;
    document.body.appendChild(target);
}
var ResultState;
(function (ResultState) {
    ResultState["OK"] = "ok";
    ResultState["CANCEL"] = "cancel";
})(ResultState || (ResultState = {}));
function showPrompt(options) {
    const promptTarget = document.createElement("div");
    target === null || target === void 0 ? void 0 : target.append(promptTarget);
    const root = createRoot(promptTarget);
    return new Promise((resolve, reject) => {
        const onConfirm = (value) => {
            if (options.promptType === "confirm" ||
                options.promptType === undefined) {
                resolve({ state: ResultState.OK });
            }
            else {
                resolve({ state: ResultState.OK, value });
            }
        };
        const onCancel = () => {
            resolve({ state: ResultState.CANCEL });
        };
        // Ensure target and body is still there when rendering. This is due
        // to an issue with ReactDOM createRoot assuming document is always there and
        // Jest taking the document down.
        if (document.body.contains(promptTarget)) {
            root.render(jsx(Prompt, Object.assign({}, options, { onCancel: onCancel, onConfirm: onConfirm })));
        }
        else {
            reject(new Error("Could not find target element in DOM"));
        }
    }).finally(() => {
        root.unmount();
    });
}

export { showPrompt };
//# sourceMappingURL=showPrompt.js.map
